import { FileText } from "lucide-react";
import { CollapsibleCard } from "../CollapsibleCard";
import { SubmissionResponseDto } from "@/dto/get-project-response.dto";

interface ProjectValuationSectionProps {
  submission: SubmissionResponseDto;
  defaultOpen?: boolean;
}

export const ProjectValuationSection = ({
  submission,
  defaultOpen = true,
}: ProjectValuationSectionProps) => {
  return (
    <CollapsibleCard
      title="1. Project Valuation & PO Details"
      defaultOpen={defaultOpen}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Project Valuation
            </span>
            <span className="text-sm font-medium">
              {submission.projectValuation
                ? Number(submission.projectValuation).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                : "Not provided"}
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              PO Number
            </span>
            <span className="text-sm font-medium">
              {submission.poNumber || "Not provided"}
            </span>
          </div>
        </div>
        {submission.files?.po && (
          <div className="md:col-span-2">
            <a
              href={submission.files.po.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-sm font-medium text-primary hover:underline"
            >
              <FileText className="mr-2 h-4 w-4" /> View PO Document
            </a>
          </div>
        )}
      </div>
    </CollapsibleCard>
  );
};
